import { Button, Grid, Tabs } from 'antd';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Form from '../../../components/fields/Form';
import FormAutoTouch from '../../../components/FormAutoTouch';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import FinanceProductForm, { type FinanceProductFormValues, Tab, useTabs } from './FinanceProductForm';

type InnerProps = {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    deleteFinanceProduct: () => void;
    updated?: string;
    offset?: string;
    permissions: { update: boolean; delete: boolean };
};

const Inner = ({ handleSubmit, deleteFinanceProduct, updated, offset, permissions }: InnerProps) => {
    const { t } = useTranslation(['financeProductDetails']);
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState<string>(Tab.MainDetails);

    const tabs = useTabs();

    const { initialValues } = useFormikContext<FinanceProductFormValues>();
    const screens = Grid.useBreakpoint();

    const { update: hasUpdatePermission, delete: hasDeletePermission } = permissions;

    return (
        <ConsolePageWithHeader
            extra={
                hasDeletePermission && (
                    <Button onClick={deleteFinanceProduct} danger>
                        {t('financeProductDetails:actions.delete')}
                    </Button>
                )
            }
            footer={[
                hasUpdatePermission && (
                    <Button key="submit" form="financeProductForm" htmlType="submit" type="primary">
                        {t('financeProductDetails:actions.update')}
                    </Button>
                ),
            ]}
            header={{
                footer: (
                    <Tabs activeKey={activeTab} onChange={setActiveTab}>
                        {tabs}
                    </Tabs>
                ),
            }}
            onBack={() => navigate('/admin/financeProducts')}
            title={
                screens.md
                    ? t('financeProductDetails:title', {
                          name: initialValues.displayName,
                          id: initialValues.identifier,
                      })
                    : `${initialValues.displayName} ${initialValues.identifier}`
            }
        >
            <Form id="financeProductForm" name="financeProductForm" onSubmitCapture={handleSubmit}>
                <FormAutoTouch />
                <FinanceProductForm
                    activeTab={activeTab}
                    disabled={!hasUpdatePermission}
                    offset={offset}
                    updated={updated}
                />
            </Form>
        </ConsolePageWithHeader>
    );
};

export default Inner;
